import React, {useEffect, useRef} from 'react';
import _ from 'lodash';
import API from '../../../app/api';
import {getConsultantName} from './clinitianUtils';
import {AutocompleteDictionary} from '../autocomplete';
import Chip from '@mui/material/Chip';

function ControlClinician(props) {
    const controller = new AbortController();
    const type = props.typeDict ? props?.typeDict : 'Clinicians';

    const init = useRef(true);

    useEffect(async () => {
        let newFilter = 'deactivated ne true';

        if (props.filterBy && props.filterBy !== '') {
            newFilter = `(${props.filterBy} eq true and deactivated ne true)`;
        }

        if (!props.loading && props.findUser && !_.isNil(props.findUser) && _.isNil(props.value) && init.current) {
            let userClinician;
            await API.getDictByURL(`/$dict/${type}?$filter=${encodeURIComponent(newFilter)}`, controller.signal).then((dictData) => {
                if (dictData) {
                    for (let clinician of dictData.__data) {
                        if (clinician.userName === props.findUser) {
                            userClinician = clinician;
                            break;
                        }
                    }
                }
            });

            if (userClinician) {
                props.onChange(userClinician, true);
                init.current = false;
            }
        }

        return () => {
            controller.abort();
        };
    }, [props.value, props.loading]);

    const getDictionaryURL = (filter) => {
        let newFilter = 'deactivated ne true';

        if (props.filterBy && props.filterBy !== '') {
            newFilter = `(${props.filterBy} eq true and deactivated ne true)`;
            if (filter !== '') {
                newFilter = `(${props.filterBy} eq true and deactivated ne true) and ` + filter;
            }
        } else {
            if (filter !== '') {
                newFilter = 'deactivated ne true and ' + filter;
            }
        }

        return `/$dict/${type}?$filter=${encodeURIComponent(newFilter)}&$sort=description`;
    };

    const getClinicianURL = (clinicianType, filter) => {
        let newFilter = 'deactivated ne true';

        if (props.filterBy && props.filterBy !== '') {
            newFilter = `(${props.filterBy} eq true and deactivated ne true)`;
            if (filter !== '') {
                newFilter = `(${props.filterBy} eq true and deactivated ne true) and ` + filter;
            }
        } else {
            if (filter !== '') {
                newFilter = 'deactivated ne true and ' + filter;
            }
        }

        return `/$dict/${clinicianType}?$filter=${encodeURIComponent(newFilter)}&$sort=description`;
    };

    const renderOptionLine = (createParts, option, classes, props) => {
        return <div {...props}>{getConsultantName(option)}</div>;
    };

    return (
        <AutocompleteDictionary
            showAll
            getOptionSelected={(option, value) => option.__id === value.__id}
            getOptionLabel={(option) => getConsultantName(option)}
            renderLocalOption={renderOptionLine}
            searchColumnName="description"
            dictionaryURL={getDictionaryURL}
            getClinicianURL={getClinicianURL}
            renderTags={(tagValue, getTagProps) => tagValue.map((option, index) => (<Chip
                label={getConsultantName(option)}
                {...getTagProps({index})}
            />))}
            isOptionEqualToValue={(option, value) => {
                return option?.__id === value?.__id;
            }}
            noBorder={!props.refresh}
            withNewBackground={props.refresh}
            {...props}
            size={props.refresh ? 'large' : props.size || 'small'}
        />
    );
}

export default ControlClinician;